export const tableColumnList = [
  {
    field: 'productTypeName',
    title: '产品',
    width: '140',
    editRender: { name: 'productTypeName' },
  },
  {
    field: 'serviceTypeName',
    title: '服务',
    width: '160',
    editRender: { name: 'serviceTypeName' },
  },
  {
    field: 'expenseNo',
    title: '费用编号',
    width: '120',
    editRender: {
      name: 'expenseNo',
    },
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    width: '120',
    editRender: {
      name: 'expenseTypeName',
    },
  },
  {
    field: 'originalPrice',
    title: '原币结算单价（含税）',
    width: '170',
    editRender: { name: 'originalPrice' },
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
    editRender: {
      name: 'settlementQuantity',
    },
  },
  {
    field: 'unitName',
    title: '计量单位',
    width: '140',
    editRender: {
      name: 'unitName',
    },
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '170',
    editRender: { name: 'originalAmount' },
  },
  {
    field: 'originalAmountWithoutTax',
    title: '原币结算金额 (不含税)',
    width: '170',
    editRender: { name: 'originalAmountWithoutTax' },
  },
  {
    field: 'originalTaxAmount',
    title: '原币税额',
    width: '140',
    editRender: { name: 'originalTaxAmount' },
  },
  {
    field: 'currencyName',
    title: '币种',
    width: '140',
    editRender: { name: 'currencyName' },
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
    editRender: { name: 'exchangeRate' },
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
    editRender: { name: 'domesticAmount' },
  },
  {
    field: 'domesticAmountWithoutTax',
    title: '本币结算金额 (不含税)',
    width: '170',
    editRender: { name: 'domesticAmountWithoutTax' },
  },
  {
    field: 'domesticTaxAmount',
    title: '本币税额',
    width: '140',
    editRender: { name: 'domesticTaxAmount' },
  },
  // {
  //   field: 'periodDateFrom',
  //   title: '业务账期日期从',
  //   width: '160',
  //   editRender: { name: 'periodDateFrom' },
  // },
  // {
  //   field: 'periodDateUntil',
  //   title: '业务账期日期至',
  //   width: '160',
  //   editRender: { name: 'periodDateUntil' },
  // },
  // {
  //   field: 'inboundDate',
  //   title: '业务日期',
  //   width: '160',
  //   editRender: { name: 'inboundDate' },
  // },
  {
    field: 'taxRate',
    title: '税率',
    width: '140',
    editRender: { name: 'taxRate' },
  },
  // {
  //   field: 'contractNo',
  //   title: '合同编号',
  //   width: '140',
  //   editRender: { name: 'contractNo' },
  // },
  // {
  //   field: 'productCode',
  //   title: '商品名称',
  //   width: '140',
  //   editRender: { name: 'productCode' },
  // },
  // {
  //   field: 'goodsCategoryName',
  //   title: '商品类别',
  //   width: '140',
  //   editRender: { name: 'goodsCategoryName' },
  // },
  // {
  //   field: 'productModel',
  //   title: '规格',
  //   width: '140',
  //   editRender: { name: 'productModel' },
  // },
  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
    editRender: { name: 'businessDocNo' },
  },

  // {
  //   field: 'delivererName',
  //   title: '投送人',
  //   width: '160',
  //   editRender: { name: 'delivererName' },
  // },
  {
    field: 'deductionOriginalAmount',
    title: '抵扣原币金额（含税）',
    width: '160',
    editRender: { name: 'deductionOriginalAmount' },
  },
  // {
  //   field: 'deductionDomesticAmount',
  //   title: '抵扣本币金额（含税）',
  //   width: '160',
  //   editRender: { name: 'deductionDomesticAmount' },
  // },

  {
    field: 'remark',
    title: '备注',
    width: '140',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  expenseType: [{ required: true, message: '必填字段' }],
  originalPrice: [{ required: true, message: '必填字段' }],
  settlementQuantity: [{ required: true, message: '必填字段' }],
  originalAmount: [{ required: true, message: '必填字段' }],
  currencyName: [{ required: true, message: '必填字段' }],
  exchangeRate: [{ required: true, message: '必填字段' }],
  periodDateFrom: [{ required: true, message: '必填字段' }],
  periodDateUntil: [{ required: true, message: '必填字段' }],
  unitName: [{ required: true, message: '必填字段' }],
  productCode: [{ required: true, message: '必填字段' }],
  domesticAmount: [{ required: true, message: '必填字段' }],
};
